import React, { useEffect } from 'react';
import { DatePicker, ImageUploader, Card, Form, Input, Space, Toast, Button } from 'antd-mobile'

const PageModel = props => {

	useEffect(() => {
	}, [ 123 ]);

	return (
		<Space
			direction="vertical"
			size="middle"
			style={{
				display: 'flex',
				marginTop: '20px',
			}}
		>
			{/* <Button color="primary" block onClick={() => props.history.push('/bigdata')}>大数据实时监控</Button> */}
			<Button block onClick={() => props.history.push('/admincompanylist')}>餐饮店新增和修改</Button>
			<Button block onClick={() => props.history.push('/equipment')}>设备管理</Button>

		</Space>
	);
};

export default PageModel;
